import { localStore } from 'utils/storage'

export enum PAYMENT_ENTRY_POINTS {
  BANNER_ABOVE_NAV = 'Banner Above Nav',
  BANNER_ABOVE_NAV_PROMO = 'Banner Above Nav Promo',
  BANNER_ABOVE_NAV_REGISTRATION = 'Banner Above Nav Registration',
  BANNER_ABOVE_NAV_DAILY_GIFTS = 'Banner Above Nav Daily Gifts',
  FLOATING_BANNER = 'Floating Banner',
  CRAFTS_PAGE = 'Crafts Page',
  GRAPHICS_PAGE = 'Graphics Page',
  PDP_TOP_BANNER = 'PDP Top Banner',
  PDP_DOWNLOAD_SIDEBAR = 'PDP Download Sidebar',
  PDP_PROMO_BOX = 'PDP Promo Box',
  PDP_RECOMMENDATIONS = 'PDP Recommendations',
  SEARCH_PAGE_CARD = 'Search Page Card',
  SEARCH_PAGE_BANNER = 'Search Page Banner',
  PROMO_PAGE = 'Promo Page',
  FREEBIES_BANNER = 'Freebies Banner',
  GRAPHICS_BOTTOM_BANNER = 'Graphics Bottom Banner',
  GRAPHICS_TOP_BANNER = 'Graphics Top Banner',
  FREEBIES_PRODUCT_PAGE = 'Freebies Product Page',
  DOWNLOAD_PAGE = 'Download Page',
  SUBSCRIPTION_PAGE = 'Subscription Page',
  MY_ACCOUNT_BANNER = 'My Account Banner',
  BUNDLES = 'Bundles',
  AUTO_TRIGGERED = 'auto-triggered',
  PDP_TOGGLE = 'pdp-toggle',
  STUDIO = 'Studio',
  SOCIAL_CLUBHOUSE_JOIN = 'Social Clubhouse Join',
  PROMO_POPUP = 'Promo Pop Up',
  MAIN_MENU_STUDIO_BUTTON = 'Main Menu Studio Button',
  MY_ACCOUNT_RECOMMENDATIONS = 'My Account Recommendations',
  PAGE_404_RECOMMENDATIONS = '404 Page Recommendations',
  HOMEPAGE_REDIRECT = 'Homepage Redirect',
  HOMEPAGE_TAKEOVER_BUTTON = 'Homepage Takeover Button',
  HOMEPAGE_HERO_BANNER = 'Homepage Hero Banner',
  CATEGORY_PAGE_IMAGE = 'Category Page Image',
  CONFIRMATION_PAGE = 'Confirmation Page',
  CONFIRMATION_PRODUCT_CARD_DOWNLOAD = 'Confirmation Product Card Download',
  SEARCH_PRODUCT_CARD_DOWNLOAD = 'Search Product Card Download',
  SEASONAL_PROMO_PAGE = 'Seasonal Promo Page',
  ONE_CLICK_UPGRADE_BUTTON = 'One Click Upgrade Button',
  ONE_CLICK_UPGRADE_TOGGLE = 'One Click Upgrade Toggle',
  FREE_TRIAL_ELIGIBLE_AGAIN_MODAL = 'Free Trial Eligible Again Modal',
  BUNDLES_BANNER = 'Bundles Banner',
  DAILY_GIFTS_UNLIMITED_CREATIVITY_MODAL = 'Daily Gifts Unlimited Creativity Modal',
  POD_FOOTER = 'POD Footer',
  PDP_STUDIO_CUSTOMIZER = 'PDP Studio Customizer',
}

const PAYMENT_ENTRY_KEY = 'cf-payment-modal-entry-point'

export const readPaymentModalEntryPoint = () => {
  const entryPoint = localStore.getString(PAYMENT_ENTRY_KEY)
  localStore.remove(PAYMENT_ENTRY_KEY)

  return entryPoint
}

export const savePaymentModalEntryPoint = (entryPoint: string) => {
  localStore.setString(PAYMENT_ENTRY_KEY, entryPoint)
}
